module.exports = __webpack_public_path__ + "media/guests/assets/accepted_cards-6d497684e9b5630fbebb56bed796739e.png";